import { Icon16Checkmark, Typography } from "@cur8/maneki";
import { Measurement } from "@cur8/rich-entity";
import { MetricGroup } from "./measurementConfig";
import {
  formatMeasurementValue,
  formatUnitPlaceholder,
} from "./measurementFormat";
import styles from "./styles.module.sass";

interface GroupTileProps {
  group: MetricGroup;
  existingByMetric: Map<string, Measurement>;
  cautionText?: string;
  onClick: () => void;
}

export function GroupTile({
  group,
  existingByMetric,
  cautionText,
  onClick,
}: GroupTileProps) {
  const isCaution = cautionText != null;
  const doneCount = group.metrics.filter((m) =>
    existingByMetric.has(m.metricName)
  ).length;
  const isDone = !isCaution && doneCount === group.metrics.length;

  return (
    <button
      type="button"
      className={styles.tile}
      data-done={isDone || undefined}
      data-caution={isCaution || undefined}
      onClick={onClick}
    >
      <div className={styles.tileHeader}>
        <Typography variant="label-s">{group.label}</Typography>
        {isDone && (
          <span className={styles.tileCheck}>
            <Icon16Checkmark />
          </span>
        )}
      </div>
      {isCaution ? (
        <Typography variant="body-s" color="subtle">
          {cautionText}
        </Typography>
      ) : (
        <div className={styles.groupValues}>
          {group.metrics.map((metric) => {
            const value =
              formatMeasurementValue(
                metric,
                existingByMetric.get(metric.metricName)
              ) ?? formatUnitPlaceholder(metric);
            return (
              <Typography
                key={metric.metricName}
                variant="body-s"
                color={isDone ? "inverted" : "subtle"}
              >
                {metric.variant ? metric.variant.value : metric.label}: {value}
              </Typography>
            );
          })}
        </div>
      )}
    </button>
  );
}
